import { AccountService } from '../../core/auth/account.service';
import { UserService } from '../../core/user/user.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FeedbackService } from '../../entities/feedback/feedback.service';
import { Router } from "@angular/router";
import { TrackerActivityFactoryService } from '../../core/tracker/tracker-activity-factory.service';
import { Feedback } from '../model/feedback.model';
import moment from "moment";
import { CUSTOMER_CARE_EMAIL_FOR_COACH } from '../../app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../core/auth/account.service";
import * as i2 from "../../core/user/user.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "../../entities/feedback/feedback.service";
import * as i5 from "@angular/router";
import * as i6 from "../../core/tracker/tracker-activity-factory.service";
import * as i7 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i8 from "@angular/common";
import * as i9 from "@angular/forms";
import * as i10 from "@fortawesome/angular-fontawesome";
import * as i11 from "../auth/has-any-authority.directive";
import * as i12 from "@ngx-translate/core";
function CustomerCareModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "fa-icon", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "a", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r0.customerCareEmail, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.customerCareEmail);
} }
function CustomerCareModalComponent_div_7_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 20);
} }
const _c0 = function () { return ["ROLE_USER"]; };
function CustomerCareModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "fa-icon", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, CustomerCareModalComponent_div_7_a_4_Template, 1, 0, "a", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(1, _c0));
} }
function CustomerCareModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "fa-icon", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "a", 22);
    i0.ɵɵtext(5, "+31613433457");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomerCareModalComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("jhiTranslate", ctx_r3.emailErrorMessage);
} }
function CustomerCareModalComponent_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("jhiTranslate", ctx_r4.messageErrorMessage);
} }
export class CustomerCareModalComponent {
    constructor(accountService, userService, modalService, feedbackService, router, trackerActivityFactoryService) {
        this.accountService = accountService;
        this.userService = userService;
        this.modalService = modalService;
        this.feedbackService = feedbackService;
        this.router = router;
        this.trackerActivityFactoryService = trackerActivityFactoryService;
        this.isAuthenticated = this.accountService.isAuthenticated();
        this.isNetherlands = false;
        this.emailError = false;
        this.messageError = false;
    }
    ngOnInit() {
        if (this.isAuthenticated) {
            this.userService.current().subscribe(u => {
                this.currentUser = u;
            });
            this.userService.customerCareEmail().subscribe(response => {
                this.customerCareEmail = response;
            });
        }
        else {
            this.customerCareEmail = CUSTOMER_CARE_EMAIL_FOR_COACH;
        }
        this.userService.getLoginCountry().subscribe(res => {
            if (res === 'Netherlands')
                this.isNetherlands = true;
        }, err => {
            console.log(err);
        });
    }
    submitMessage() {
        let message = new Feedback();
        message.email = this.email;
        message.phone = this.phone;
        message.message = this.message;
        message.creationDate = moment();
        message.userId = this.isAuthenticated ? this.currentUser.id : this.trackerActivityFactoryService.getIdKey();
        message.location = this.router.url;
        console.log(message);
        if (message.email == null || message.email === '') {
            this.emailError = true;
            this.emailErrorMessage = 'global.menu.support.emailErrorMessage';
            return;
        }
        if (message.message == null || message.message === '') {
            this.messageError = true;
            this.messageErrorMessage = 'global.menu.support.messageErrorMessage';
            return;
        }
        this.customerCareSubscription = this.feedbackService.sendFeedbackMessage(message).subscribe(() => {
            console.log('Message has been sent successfully.');
            this.modalService.dismissAll();
        }, () => {
            console.log('Message cannot be sent.');
        });
    }
    getMessageLength() {
        return !this.message ? 0 : this.message.length;
    }
    ngOnDestroy() {
        if (this.customerCareSubscription) {
            this.customerCareSubscription.unsubscribe();
        }
    }
}
CustomerCareModalComponent.ɵfac = function CustomerCareModalComponent_Factory(t) { return new (t || CustomerCareModalComponent)(i0.ɵɵdirectiveInject(i1.AccountService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.FeedbackService), i0.ɵɵdirectiveInject(i5.Router), i0.ɵɵdirectiveInject(i6.TrackerActivityFactoryService)); };
CustomerCareModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomerCareModalComponent, selectors: [["customer-care-modal"]], decls: 30, vars: 18, consts: [[1, "modal-body"], [2, "padding", "0 10px 0 10px"], [1, "d-flex", "align-items-center", "mb-1"], [2, "height", "2rem", "width", "1.6rem", "filter", "invert(50%) sepia(54%) saturate(385%) hue-rotate(116deg) brightness(101%) contrast(89%)"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#whatsapp"], ["tabindex", "-1", "href", "https://wa.me/31613433457", "target", "_blank", "jhiTranslate", "global.menu.support.inukaCustomerCare", 2, "color", "#44A38D"], ["class", "d-flex align-items-center mb-1", 4, "ngIf"], [1, "mb-2"], ["jhiTranslate", "global.menu.support.leaveMessage", 2, "font-weight", "bold", "text-align", "center"], [1, "block", "text-center"], ["type", "text", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange", "focusin"], ["style", "font-size: 10px; color: red;", 3, "jhiTranslate", 4, "ngIf"], ["type", "tel", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["rows", "5", "maxlength", "250", 1, "form-control", 2, "height", "60px", 3, "ngModel", "placeholder", "ngModelChange", "focusin"], [1, "d-flex", "justify-content-between"], [1, "text-right"], ["type", "button", "jhiTranslate", "global.menu.support.submit", 1, "btn-2", "btn-2-green", 2, "width", "120px", 3, "click"], ["icon", "envelope", 2, "color", "#44a38d", "font-size", "25px"], ["tabindex", "-1", 2, "color", "#44A38D", 3, "href"], ["tabindex", "-1", "jhiTranslate", "global.menu.support.customerCare", "routerLink", "/session/inbox/customer-care", "target", "_blank", 4, "jhiHasAnyAuthority"], ["tabindex", "-1", "jhiTranslate", "global.menu.support.customerCare", "routerLink", "/session/inbox/customer-care", "target", "_blank"], ["icon", "phone", 2, "color", "#44a38d", "font-size", "25px"], ["href", "tel:+31613433457", 2, "color", "#44A38D", "padding-left", "16px!important"], [2, "font-size", "10px", "color", "red", 3, "jhiTranslate"]], template: function CustomerCareModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(3, "svg", 3);
        i0.ɵɵelement(4, "use", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(5, "a", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, CustomerCareModalComponent_div_6_Template, 6, 2, "div", 6);
        i0.ɵɵtemplate(7, CustomerCareModalComponent_div_7_Template, 5, 2, "div", 6);
        i0.ɵɵtemplate(8, CustomerCareModalComponent_div_8_Template, 6, 0, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "hr", 7);
        i0.ɵɵelement(10, "p", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵelementStart(12, "input", 10);
        i0.ɵɵlistener("ngModelChange", function CustomerCareModalComponent_Template_input_ngModelChange_12_listener($event) { return ctx.email = $event; })("focusin", function CustomerCareModalComponent_Template_input_focusin_12_listener() { return ctx.emailError = false; });
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, CustomerCareModalComponent_span_14_Template, 1, 1, "span", 11);
        i0.ɵɵelement(15, "br");
        i0.ɵɵelementStart(16, "div", 9);
        i0.ɵɵelementStart(17, "input", 12);
        i0.ɵɵlistener("ngModelChange", function CustomerCareModalComponent_Template_input_ngModelChange_17_listener($event) { return ctx.phone = $event; });
        i0.ɵɵpipe(18, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "br");
        i0.ɵɵelementStart(20, "div", 9);
        i0.ɵɵelementStart(21, "textarea", 13);
        i0.ɵɵlistener("ngModelChange", function CustomerCareModalComponent_Template_textarea_ngModelChange_21_listener($event) { return ctx.message = $event; })("focusin", function CustomerCareModalComponent_Template_textarea_focusin_21_listener() { return ctx.messageError = false; });
        i0.ɵɵpipe(22, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 14);
        i0.ɵɵelementStart(24, "div");
        i0.ɵɵtemplate(25, CustomerCareModalComponent_span_25_Template, 1, 1, "span", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 15);
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 9);
        i0.ɵɵelementStart(29, "button", 16);
        i0.ɵɵlistener("click", function CustomerCareModalComponent_Template_button_click_29_listener() { return ctx.submitMessage(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !ctx.isAuthenticated);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAuthenticated);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isNetherlands);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 12, "global.menu.support.email"));
        i0.ɵɵproperty("ngModel", ctx.email);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.emailError && ctx.emailErrorMessage);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 14, "global.menu.support.phone"));
        i0.ɵɵproperty("ngModel", ctx.phone);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(22, 16, "global.menu.support.tellUs"));
        i0.ɵɵproperty("ngModel", ctx.message);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.messageError && ctx.messageErrorMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.getMessageLength(), " / 250");
    } }, directives: [i7.JhiTranslateDirective, i8.NgIf, i9.DefaultValueAccessor, i9.NgControlStatus, i9.NgModel, i9.MaxLengthValidator, i10.FaIconComponent, i11.HasAnyAuthorityDirective, i5.RouterLinkWithHref], pipes: [i12.TranslatePipe], styles: [".modal-body{text-align:center}a{padding-left:16px;text-decoration:none}a.dropdown-toggle{padding-left:0 !important}a.support-dropdown-item{margin-right:.5rem !important;background-color:#fff;color:#44a38d !important}a.support-dropdown-item>img{padding-right:.5rem;filter:invert(52%) sepia(63%) saturate(331%) hue-rotate(116deg) brightness(95%) contrast(91%)}a.support-dropdown-item:hover{margin-right:.5rem !important;background-color:#44a38d;color:#fff !important}a.support-dropdown-item:hover>img{padding-right:.5rem;filter:brightness(0) invert(1)}.dropdown-toggle::after{display:none}.feedback-star-hover{color:#44a38d}.feedback-stars .feedback-stars-container .feedback-star{display:inline-block;font-size:22px;cursor:pointer;padding:5px;color:#ebedf5}.feedback-stars-container{text-align:center}.support-label{font-size:16px;color:#44a38d}.dropdown-menu-location{top:30px !important;right:25px !important}"], encapsulation: 2 });
